import React from 'react'
import { AlertRec } from '../StdLib'

export default function Contact() {

  // AlertRec(_AccRecs, 'ABOUT PAGE ******************** NEAT _AccRec in main prgb**********************')
  return (
    <>
      <div >
        
        <div className='w-full md:flex '>
        <div className='mx-auto w-full md:w-1/2 p-10 '>
            <div className='mx-auto w-full  rounded-xl shadow-xl overflow-hidden'>
              <img className='w-full h-full object-fill' src={'/Images/UnderConstruction/UC-7.png'} alt={''} />
            </div>
          </div>

          <div className='px-2 md:px-40 w-full md:w-1/2'>
            <p className='text-5xl mt-10 font-poppins'>Welcome!</p>

            <p className='text-5xl mt-10 font-poppins text-blue-600'>Smart Business Applications</p>

            <div className='mt-4'>
              <p className='text-2xl font-poppins'>Main Office</p>
              <p className='text-base font-poppins px-4'># 12345</p>
              <p className='text-base font-poppins px-4'>Zeroth Floor, Mall o Mall Plaza,</p>
              <p className='text-base font-poppins px-4'>Izmeer Housing </p>
              <p className='text-base font-poppins px-4'>Lahore </p>
              <p className='text-base font-poppins px-4'>Phone: +92 XX 1122334455 </p>
            </div>

            <div className='mt-4'>
              <p className='text-2xl font-poppins'>Business Center</p>
              <p className='text-base font-poppins px-4'>#36/3</p>
              <p className='text-base font-poppins px-4'>Altaf Town </p>
              <p className='text-base font-poppins px-4'>Tariq Road </p>
              <p className='text-base font-poppins px-4'>Multan, Pakistan </p>
              <p className='text-base font-poppins px-4'>Phone: +92 334 4373507 </p>
            </div>
          </div>

        </div>
      </div>

    </>
  )
}
